import React, { useState } from 'react';

import { Grid, Typography } from '@mui/material';

import { cardTitle } from 'src/App/Dashboards/Market/styles/style';
import { DynamicPieChart } from 'src/App/Dashboards/Market/Components/Charts';
import { PieDataCardPropTypes } from 'src/interfaces/iproptypes';
import { InfoButton } from 'src/App/Dashboards/Market/Components/Buttons';

const PieDataCard = ({
  title,
  tooltipContent,
  data,
  unit,
  label,
  pieColors,
  pieAccentColor,
  radius,
  tooltipTextSuffix,
  getTooltipText,
  parent,
}: PieDataCardPropTypes) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return (
    // <Card>
    // <CardContent>
    <Grid container direction="column" justifyContent="space-between" alignItems="flex-start" item>
      {title && (
        <Typography variant="h2" sx={cardTitle}>
          {title}
          {tooltipContent && <InfoButton title={title} tooltipContent={tooltipContent} />}
        </Typography>
      )}

      <Grid container item justifyContent={'flex-start'} xs={12}>
        <DynamicPieChart
          data={data}
          unit={unit}
          pieColors={pieColors}
          pieAccentColor={pieAccentColor}
          label={label}
          radius={radius}
          tooltipTextSuffix={tooltipTextSuffix}
          getTooltipText={getTooltipText}
          parent={parent}
        />
      </Grid>
    </Grid>
    // </CardContent>
    // </Card>
  );
};

export default React.memo(PieDataCard);
